import React, { FC, Dispatch, SetStateAction, ReactNode } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';

interface AcceptanceConfirmationModalProps {
  onConfirm: () => void;
  message: ReactNode;
  modalOpen: boolean;
  setModalOpen: Dispatch<SetStateAction<boolean>>;
  title?: any;
}

const AcceptanceConfirmationModal: FC<AcceptanceConfirmationModalProps> = (props) => {
  let { onConfirm, message, modalOpen, setModalOpen, title } = props;

  const handleConfirmClicked = () => {
    setModalOpen(false);
    onConfirm();
  };

  return (
    <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
      <Grid container spacing={2} style={{ minWidth: '400px', padding: '30px' }}>
        <Grid item xs={12}>
          <Typography variant="h5">{title}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6">{message}</Typography>
        </Grid>
        <Grid item xs={3}>
          <Button variant="contained" onClick={handleConfirmClicked}>
            Confirm
          </Button>
        </Grid>
        <Grid item xs={3}>
          <Button variant="contained" onClick={() => setModalOpen(false)} color="inherit">
            Cancel
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default AcceptanceConfirmationModal;
